import * as React from 'react'
import { useTheme } from 'styled-components'
import { InterventionPlace, offeredServiceI18nInterventionPlace } from '../../../../services/models/offered-services.service'
import { CastingStore } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import ButtonGroupComponent from '../../../shared/button-group.component'

interface Props {
  data: CastingStore['data']
  store: CastingStore
  itemByLine?: number
  style?: React.CSSProperties
}

const i18nScoped = new I18nService(require('./casting-required-place-intervention-place.component.yml'))

export default function CastingRequirePlaceInterventionPlaceComponent ({ data: { offeredService, city, requiredPlace }, store, itemByLine, style }: Props) {
  const theme = useTheme()
  
  const setRequiredPlace = React.useCallback((requiredPlace: InterventionPlace) => {
    store.setRequiredPlace(requiredPlace)
    if (requiredPlace !== 'on_site' || store.data.serviceDeliveryLocation) store.nextFocus()
  }, [store])

  if (!city || !offeredService.rentable) return null

  return <>
    { offeredService.intervention_places.length === 1 && offeredService.intervention_places[0] !== 'on_site' && <div style={{ padding: '0.5em' }}>
      { i18nScoped.t('title') } <span style={{ color: theme.colors.clr_1 }}>{ offeredServiceI18nInterventionPlace(requiredPlace) }</span>
    </div> }

    { offeredService.intervention_places.length > 1 && <ButtonGroupComponent
      style={ style }
      reemitOnClick
      name="requiredPlace"
      value={ requiredPlace }
      onChange={ setRequiredPlace }
      data={ offeredService.intervention_places.map(place => ({ value: place, text: offeredServiceI18nInterventionPlace(place) })) }
      itemByLine={ itemByLine || offeredService.intervention_places.length } /> }
  </>
}
